import { render } from "./DataCollectionUploads.vue?vue&type=template&id=1b28e964&scoped=true"
import script from "./DataCollectionUploads.vue?vue&type=script&lang=js"
export * from "./DataCollectionUploads.vue?vue&type=script&lang=js"

import "./DataCollectionUploads.vue?vue&type=style&index=0&id=1b28e964&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b28e964"]])

export default __exports__